import "./PreviewCard.css";

export default function PreviewCard({ campaign }) {
  const renderBody = () => {
    if (!campaign.body.trim()) {
      return (
        <div className="preview-empty">
          Empieza a escribir el mensaje para ver la vista previa...
        </div>
      );
    }

    return campaign.body
      .split("\n")
      .map((line, index) => (
        <p key={index}>{line}</p>
      ));
  };

  return (
    <div className="campaign-card">

      <div className="campaign-card-header">

        <div className="campaign-card-icon">
          <i className="fa-solid fa-eye"></i>
        </div>

        <div>

          <h2>Vista previa</h2>

          <p>
            Así verán el correo los destinatarios.
          </p>

        </div>

      </div>

      <div className="email-preview">

        <div className="preview-top">

          <img
            src="/logo-email.png"
            alt="TE AYUDO"
          />

        </div>

        <div className="preview-content">

          <h3>

            {campaign.subject || "Sin asunto"}

          </h3>

          {renderBody()}

        </div>

        <div className="preview-footer">

          <strong>

            Equipo TE AYUDO

          </strong>

          <span>

            www.centroteayudo.es

          </span>

        </div>

      </div>

    </div>
  );
}